var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_835_2694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 9C1 4.58172 4.58172 1 9 1H13C21.8366 1 29 8.16344 29 17V18C29 22.4183 25.4183 26 21 26H9C4.58172 26 1 22.4183 1 18V9Z",
    fill: "white",
    fillOpacity: 0.65,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9C1.5 4.85786 4.85786 1.5 9 1.5H13C21.5604 1.5 28.5 8.43959 28.5 17V18C28.5 22.1421 25.1421 25.5 21 25.5H9C4.85786 25.5 1.5 22.1421 1.5 18V9Z",
    stroke: "url(#paint0_linear_835_2694)",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.375 5.6665C16.0103 5.6665 15.6606 5.81137 15.4027 6.06923C15.1448 6.32709 15 6.67683 15 7.0415C15 7.40618 15.1448 7.75591 15.4027 8.01378C15.6606 8.27164 16.0103 8.4165 16.375 8.4165C16.7396 8.4165 17.0894 8.27164 17.3472 8.01378C17.6051 7.75591 17.75 7.40618 17.75 7.0415C17.75 6.67683 17.6051 6.32709 17.3472 6.06923C17.0894 5.81137 16.7396 5.6665 16.375 5.6665ZM16.045 10.039C14.9541 10.1307 11.975 12.5048 11.975 12.5048C11.7916 12.6423 11.8466 12.6332 11.9933 12.8898C12.14 13.1373 12.1216 13.1557 12.2958 13.0365C12.4791 12.9173 12.7816 12.7248 13.2858 12.4132C15.2291 11.1665 13.5975 14.0448 12.7633 18.894C12.4333 21.2957 14.5966 20.0582 15.1558 19.6915C15.7058 19.334 17.1816 18.3165 17.3283 18.2157C17.53 18.0782 17.3833 17.9682 17.2275 17.739C17.1175 17.5832 17.0075 17.6932 17.0075 17.6932C16.4116 18.0873 15.3208 18.9123 15.1741 18.3898C15 17.8673 16.1183 14.2832 16.7325 11.8173C16.8333 11.2307 17.1083 9.94734 16.045 10.039Z",
    fill: "#302955"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_835_2694",
    x: 0.6,
    y: 0.6,
    width: 28.8,
    height: 25.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.556863 0 0 0 0 0.329412 0 0 0 0 0.913725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_835_2694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_835_2694",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_835_2694",
    x1: 17.429,
    y1: 26,
    x2: 10.6381,
    y2: 4.75038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F4981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76727C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIBtn);
export default __webpack_public_path__ + "static/media/i_btn.a7ebd7d8ff53f6f1f2d74f3e3ba8f08c.svg";
export { ForwardRef as ReactComponent };